import { render, staticRenderFns } from "./ReservationsToday.vue?vue&type=template&id=51b7f625"
import script from "./ReservationsToday.vue?vue&type=script&lang=js"
export * from "./ReservationsToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports